import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface AdminSeafLoadingState {
  visible: boolean;
  mensaje: string;
  titulo: string;
}
export interface LoadingPaso {
  id: string;
  nombre: string;
  icono: string;
  visible: boolean;
  estado: 'pendiente' | 'cargando' | 'completado' | 'error';
}

export interface AdminSeafLoadingState {
  visible: boolean;
  mensaje: string;
  titulo: string;
  pasos: LoadingPaso[];
}
@Injectable({
  providedIn: 'root'
})
export class AdminSeafLoadingService {

  private estadoSubject = new BehaviorSubject<AdminSeafLoadingState>({
    visible: false,
    mensaje: 'Preparando tu entorno de trabajo',
    titulo: 'Iniciando Admin SEAF',
    pasos: []
  });

  estado$ = this.estadoSubject.asObservable();
  constructor() {
   // console.log('AdminSeafLoadingService initialized');
  }

mostrar(
  mensaje = 'Preparando tu entorno de trabajo',
  pasos?: LoadingPaso[],
  titulo?: string,
): void {
  this.estadoSubject.next({
    visible: true,
    mensaje,
    titulo: titulo ?? 'Iniciando Admin SEAF',
    pasos: pasos ?? [
      {
        id: 'gps',
        nombre: 'Conectando GPS',
        icono: '⌁',
        visible: false,
        estado: 'pendiente'
      },
      {
        id: 'datos',
        nombre: 'Cargando datos',
        icono: '▤',
        visible: true,
        estado: 'cargando'
      },
      {
        id: 'modulos',
        nombre: 'Preparando módulos',
        icono: '⚙',
        visible: true,
        estado: 'pendiente'
      },
      {
        id: 'listo',
        nombre: 'Todo listo para tu flota',
        icono: '✓',
        visible: true,
        estado: 'pendiente'
      }
    ]
  });
}

actualizarPaso(
  id: string,
  cambios: Partial<LoadingPaso>,
  mensaje?: string
): void {
  const actual = this.estadoSubject.value;

  this.estadoSubject.next({
    ...actual,
    titulo: actual.titulo,
    mensaje: mensaje ?? actual.mensaje,
    pasos: actual.pasos.map(paso =>
      paso.id === id ? { ...paso, ...cambios } : paso
    )
  });
}

ocultar(): void {
  this.estadoSubject.next({
    visible: false,
    titulo: 'Iniciando Admin SEAF',
    mensaje: 'Preparando tu entorno de trabajo',
    pasos: []
  });
}
  
}

